import { useSearchParams } from "@remix-run/react";

export const useShopSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const updateSearchParams = (key: string, value: string) => {
    setSearchParams(
      (sp) => {
        sp.has(key, value) ? sp.delete(key, value) : sp.append(key, value);
        return sp;
      },
      { preventScrollReset: true },
    );
  };

  const clearSearchParams = () => {
    setSearchParams(
      (sp) => {
        sp.delete("brand");
        sp.delete("category");
        sp.delete("subcategory");
        return sp;
      },
      { preventScrollReset: true },
    );
  };

  return {
    updateSearchParams,
    clearSearchParams,
    selected: {
      brands: searchParams.getAll("brand"),
      categories: searchParams.getAll("category"),
      subcategories: searchParams.getAll("subcategory"),
    },
  };
};
